module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter15"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch15"
    }
  }, [_vm._v("White Bean and Rosemary Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Creamy, tender white beans, chunks of spicy Capicola or other ham, and rosemary combine for a hearty soup that is terrific to serve for lunch or as part of a soup-andsandwich supper. Try serving this soup with grown-up grilled cheese—panini made with fontina, provolone, and fresh mozzarella topped with pesto. Now that’s a great meal!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 tablespoons extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 ounces of spicy Italian ham or Capicola, cut into ½-inch dice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 medium onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 stalks celery with leaves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 medium carrots, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons finely minced fresh rosemary")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One 14- to 15-ounce can plum tomatoes, crushed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups dried beans, picked over for stones, soaked, or two 14- to 15-ounce cans small white beans, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 cups chicken or vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a skillet over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the ham and sauté until it begins to get crisp, about 3 minutes. Add the onion, garlic, celery, carrots, and rosemary and sauté until the vegetables begin to soften, about 3 minutes. Add the tomatoes and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Stir in the beans and the broth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on low for 8 to 9 hours, until the beans are tender. Season with salt and pepper before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b9f9851","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/021-chapter15.vue
// module id = 117
// module chunks = 0